export const LOAD_OFFER_SUMMARY_SUCCEEDED = "LOAD_OFFER_SUMMARY_SUCCEEDED";
export const LOAD_OFFER_SUMMARY_FAILED = "LOAD_OFFER_SUMMARY_FAILED";
export const LOAD_OFFER_KPI_SUCCEEDED = "LOAD_OFFER_KPI_SUCCEEDED";
export const LOAD_OFFER_KPI_FAILED = "LOAD_OFFER_KPI_FAILED";
